import React, { useState, useCallback, useEffect } from 'react'
import { classingModalModes, defaultModalModes } from '../../assets/const'
import { Curator, History, Main, Team } from './ModalTabs'
import Modal from '../../components/Modal'
import { ClassingContext } from '../../utils/context'
import Confirmation from '../../components/Confirmation/Confirmation'

export default function ModalComponent({ classId, closeModal, classing, infoCreateChange, mode, setMode }) {

  const [confirmClose, setConfirmClose] = useState(false)

  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

  // Сброс на «Главная» при каждом открытии
  useEffect(() => {
    if (classId) setMode('main')
  }, [classId])

  const renderTab = () => {
    switch (mode) {
      case 'main': return <Main />
      case 'curator': return <Curator />
      case 'history': return <History />
      case 'team': return <Team />
      default: return
    }
  }

  const isNew = classId === 'add'
  const disabledTabs = isNew
    ? classingModalModes.filter(m => m.value !== 'main').map(m => m.value)
    : []

  return (
    <ClassingContext.Provider value={{ classId, closeModal, classing, infoCreateChange }}>
      <Modal
        open={!!classId}
        classId={classId}
        menuItem={mode}
        setMenuItem={setMode}
        menuList={classingModalModes}
        disabledItems={disabledTabs}
        onClose={handleClose}
        closeOnOverlayClick={true}
        closeOnEsc={true}
        classing
      >
        {renderTab()}
        {confirmClose && (
          <Confirmation
            title="Закрыть без сохранения изменений?"
            acceptConfirmation={acceptConfirmation}
            rejectConfirmation={rejectConfirmation}
          />
        )}
      </Modal>
    </ClassingContext.Provider>
  )
}

